import React, { useState, useEffect } from 'react';
import ThresholdApprovalPopup from './ThresholdApprovalPopup';

const TestApprovalPopup = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [roleInfo, setRoleInfo] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUserData();
    loadPendingRequests();
  }, []);

  const loadUserData = async () => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        setUserInfo({ error: 'No user in localStorage' });
        return;
      }

      const user = JSON.parse(userStr);
      setUserInfo(user);

      // Fetch role from backend
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/${user.id}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.ok) {
        const userData = await response.json();
        setRoleInfo(userData.data);
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      setUserInfo({ error: error.message });
    }
  };

  const loadPendingRequests = async () => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;

      const user = JSON.parse(userStr);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/wastage/threshold-approvals/pending?userId=${user.id}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'X-Business-Id': user.businessId
          }
        }
      );

      if (response.ok) {
        const result = await response.json();
        setPendingRequests(result.data || []);
      }
    } catch (error) {
      console.error('Error loading pending requests:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>🧪 Wastage Threshold Approval Test Page</h1>
      
      <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>📋 Current User Info</h2>
        <pre style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
          {JSON.stringify(userInfo, null, 2)}
        </pre>
      </div>

      <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>👤 Role Information (from backend)</h2>
        <pre style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
          {JSON.stringify(roleInfo, null, 2)}
        </pre>
        {roleInfo && (
          <div style={{ marginTop: '10px', padding: '10px', backgroundColor: roleInfo.role_name?.toLowerCase() === 'owner' ? '#d4edda' : '#fff3cd', borderRadius: '4px' }}>
            <strong>Role:</strong> {roleInfo.role_name || 'Unknown'}
            <br />
            <strong>Can approve thresholds:</strong> {roleInfo.role_name?.toLowerCase() === 'owner' ? '✅ YES' : '❌ NO'}
          </div>
        )}
      </div>

      <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>📊 Pending Approval Requests</h2>
        {loading ? (
          <p>Loading...</p>
        ) : pendingRequests.length > 0 ? (
          <div>
            <p style={{ color: 'green', fontWeight: 'bold' }}>✅ Found {pendingRequests.length} pending request(s)</p>
            <pre style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px', overflow: 'auto', maxHeight: '300px' }}>
              {JSON.stringify(pendingRequests, null, 2)}
            </pre>
          </div>
        ) : (
          <p style={{ color: 'orange' }}>⚠️ No pending approval requests in database</p>
        )}
      </div>

      <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#e3f2fd', borderRadius: '8px' }}>
        <h2>🎯 Test Popup</h2>
        <button
          onClick={() => setShowPopup(true)}
          style={{
            padding: '15px 30px',
            fontSize: '16px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          🚀 Show Approval Popup
        </button>
        <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
          Click this button to manually trigger the approval popup (same one that appears on Dashboard)
        </p>
      </div>

      <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
        <h3>📝 How to Test:</h3>
        <ol>
          <li>
            <strong>As Manager (rupesh):</strong>
            <ul>
              <li>Login as rupesh</li>
              <li>Go to Wastage Thresholds page</li>
              <li>Change any threshold value</li>
              <li>Click Submit</li>
              <li>Check if request appears in "Pending Approval Requests" section above</li>
            </ul>
          </li>
          <li>
            <strong>As Owner (puli):</strong>
            <ul>
              <li>Refresh this test page</li>
              <li>Click "Show Approval Popup" button</li>
              <li>You should see the pending request(s)</li>
              <li>Test Approve/Reject buttons</li>
            </ul>
          </li>
        </ol>
      </div>

      {showPopup && (
        <ThresholdApprovalPopup
          onClose={() => {
            setShowPopup(false);
            loadPendingRequests(); // Reload after closing
          }}
        />
      )}
    </div>
  );
};

export default TestApprovalPopup;
